export const greenish = "#33da80";
export const bluish = "#281478";
export const grayish = "#c4c4c4";
export const light_gray = "#d9d9d9";
export const cyanish = "#e6f0ff";
export const black = "#2b2b30"; // temporary change
export const white = "#ffffff";
export const off_black = "#2b2b30";
export const purplish = "#4b32be";
export const darker_blue = "#96a8ff";
export const darker_grayish = "#9f9f9f";
export const faint_grayish = "#f0f0f0";
export const faint_purplish = "#f7f6fa";
export const statement_red = "#c14a4a";
export const statement_green = "#4ac14a";
export const bright_black = "#333333";
export const dark_yellow = "#bc892e";
export const light_yellow = "#ffefbc";
export const ppip_yellow = "#e8b914";
export const ppip_purple = "#f3f1ff";
export const assets_cyanish = "#31b1f9";
export const danger_red = "#da3333";
export const referrer_color = "#275dc5";
export const shaded_gray = "#6a6a6a";
export const orangish = "#ffa800";

export const narrowScreenMediaQuery = "screen and (max-width: 719px)";
